export class UserModel {
    constructor(
        public employee_id?: string,
        public employee_first_name?: string,
        public employee_last_name?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/user-model.ts